import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const MarketingConsentsIcon: React.FC<NormalIconProps> = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" fill="none" className={props.className}>
		<path
			fill="#6DD997"
			d="M.378 3.082C0 3.62 0 5.22 0 8.417v1.574c0 5.638 4.239 8.375 6.899 9.536C7.62 19.842 7.981 20 9 20c1.02 0 1.38-.158 2.101-.473C13.761 18.365 18 15.63 18 9.991V8.417c0-3.198 0-4.797-.378-5.335-.377-.537-1.88-1.052-4.887-2.081l-.573-.196C10.595.268 9.812 0 9 0c-.811 0-1.595.268-3.162.805L5.265 1C2.258 2.03.755 2.545.378 3.082Z"
			opacity=".3"
		/>
		<path
			fill="#0CBF50"
			d="M12.06 8.5a.751.751 0 0 0-1.12-1l-3.011 3.374-.87-.974a.75.75 0 0 0-1.118 1l1.428 1.6a.749.749 0 0 0 1.119 0l3.572-4Z"
		/>
	</svg>
);
